
import Cta from '@/components/ui/cta.vue';
import Link from '@/components/ui/link.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'List',

  components: {
    Cta,
    Link,
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    backgroundColor() {
      return this.data.banner_background
        ? { 'background-color': this.data.banner_background }
        : null;
    },
  },
};
